import dayjs from "dayjs";
import { AreaChart } from "src/design";
import { Card } from "src/design/Card";
import { useTranslation } from "react-i18next";
import { BookingsTrendPoint } from "src/data/admin/types/analytics";
import { AnalyticsCardHeader } from "./AnalyticsCardHeader";

interface Props {
  data: BookingsTrendPoint[];
  days: number;
}

export const BookingsTrend = ({ data, days }: Props) => {
  const { t } = useTranslation();
  const bookingsKey = t("analytics.trend.bookings");
  const guestsKey = t("analytics.trend.guests");

  const chartData = data.map((point) => ({
    name: point.date,
    [bookingsKey]: point.bookings,
    [guestsKey]: point.guests,
  }));

  // Thin the ticks so labels never collide on dense ranges: aim for ~8 visible
  // labels, angled so adjacent compact "D MMM" labels stay readable.
  const tickInterval = Math.max(0, Math.ceil(chartData.length / 8) - 1);

  return (
    <Card sx={{ flexDirection: "row", gap: 0, height: "100%" }}>
      <AnalyticsCardHeader
        title={t("analytics.trend.title")}
        subtitle={t("analytics.trend.subtitle", { days })}
      />
      <AreaChart
        data={chartData}
        dataKeys={[bookingsKey, guestsKey]}
        xAxisTickFormatter={(value) => dayjs(value).format("D MMM")}
        xAxisInterval={tickInterval}
        xAxisAngle={-35}
        compact
      />
    </Card>
  );
};
